import { ok } from '@xlearn/common';
import { parseCMIString255, parseCMIString4096,
         parseCMIString1000, parseCMIString64000,
         parseCMIString } from './cmi-string';

export function setCMIString255(current: string, value: string) {
  return parseCMIString255(value);
}

export function setCMIString4096(current: string, value: string) {
  return parseCMIString4096(value);
}

export function setCMIString1000(current: string, value: string) {
  return parseCMIString1000(value);
}

export function setCMIString64000(current: string, value: string) {
  return parseCMIString64000(value);
}

export function setCMIString4000(current: string, value: string) {
  return parseCMIString(4000, value);
}

export function getCMIString4000(value: string) {
  return ok(value);
}

export function setCMIString250(current: string, value: string) {
  return parseCMIString(250, value);
}

export function getCMIString250(value: string) {
  return ok(value);
}
